import BigNumber from "bignumber.js";

export const getters = {

};